import iconSprite from '@/static/assets/lemonade_goes_global/icon-sprite.svg';
import { Flex } from '@lemonade-hq/cdk';
import { Button, MEDIA_QUERIES } from '@lemonade-hq/nuis';
import type React from 'react';
import styled, { css, type FlattenSimpleInterpolation } from 'styled-components';

const TWITTER_BASE_URL = 'http://twitter.com/share?';
const LINKEDIN_BASE_URL = 'https://www.linkedin.com/sharing/share-offsite?url=';
const FACEBOOK_BASE_URL = ' https://www.facebook.com/sharer/sharer.php?u=';

function shareOnTwitter(text: string, url = window.location.href) {
  const params: { [key: string]: string } = {
    url,
    text,
    original_referer: window.location.href,
  };
  let shareUrl = TWITTER_BASE_URL;
  for (const prop in params) shareUrl += `&${prop}=${encodeURIComponent(params[prop])}`;
  window.open(
    shareUrl,
    'shareBtnTWWindow',
    'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0',
  );
}

function shareOnLinkedin(url = window.location.href) {
  const shareUrl = LINKEDIN_BASE_URL + encodeURIComponent(url);
  window.open(shareUrl, 'shareBtnLIWindow', 'width=550,height=448,resizable,scrollbars=yes,status=1');
}

function shareOnFacebook(url = window.location.href) {
  const shareUrl = FACEBOOK_BASE_URL + encodeURIComponent(url);
  window.open(shareUrl, 'shareBtnFBWindow', 'width=555,height=655,resizable,scrollbars=yes,status=1');
}

const facebookIcon = css`
  width: 13px;
  height: 25px;
  background-position: -201px -25px;
  transform: scale(0.8);
`;

const linkedinIcon = css`
  width: 19px;
  height: 20px;
  background-position: -230px -1px;
  transform: scale(1.3);
`;

const twitterIcon = css`
  width: 28px;
  height: 28px;
  background-position: -223px -24px;
  transform: scale(0.8);
`;

const ShareButton = styled(Button)<{ icon: FlattenSimpleInterpolation }>`
  flex: 1 1;
  max-width: 100px;
  border-radius: 5px;
  height: 50px;
  border: none;
  padding: 0;
  background-color: ${props => props.color} !important;

  ${MEDIA_QUERIES.tabletAndDesktop`
        height: 40px;
    `}

  &:hover {
    filter: brightness(90%);
  }

  &:before {
    content: '';
    background: url(${iconSprite.src}) no-repeat;
    background-size: 350px 100px;
    display: block;
    margin: 0 auto;
    ${props => props.icon}
  }

  &:not(:last-child) {
    margin-right: 13px;
  }
`;

export const SHARE_CONFIG = {
  facebook: {
    dataEvent: 'transparency_page_facebook_share_button_clicked',
    color: '#3B5998',
    share: () => shareOnFacebook(),
  },
  linkedin: {
    dataEvent: 'transparency_page_linkedin_share_button_clicked',
    color: '#0077B5',
    share: () => shareOnLinkedin(),
  },
  twitter: {
    title:
      'Mic drop! @Lemonade_Inc just went full on transparent again, revealing the latest stats! Get exclusive reports here:',
    dataEvent: 'transparency_page_twitter_share_button_clicked',
    color: '#1DA1F2',
    share: (text: string) => shareOnTwitter(text),
  },
};

interface ShareProps {
  mt?: number;
}

export const Share: React.FC<ShareProps> = ({ mt = 120 }) => {
  return (
    <Flex px={[10, 20]} width={1} justifyContent="center" mt={`${mt}px`} flexDirection="row">
      <ShareButton
        icon={facebookIcon}
        color={SHARE_CONFIG.facebook.color}
        onClick={SHARE_CONFIG.facebook.share}
        data-event={SHARE_CONFIG.facebook.dataEvent}
      />
      <ShareButton
        icon={linkedinIcon}
        color={SHARE_CONFIG.linkedin.color}
        onClick={SHARE_CONFIG.linkedin.share}
        data-event={SHARE_CONFIG.linkedin.dataEvent}
      />
      <ShareButton
        icon={twitterIcon}
        color={SHARE_CONFIG.twitter.color}
        onClick={() => SHARE_CONFIG.twitter.share(SHARE_CONFIG.twitter.title)}
        data-event={SHARE_CONFIG.twitter.dataEvent}
      />
    </Flex>
  );
};
